import { FC, useEffect, useRef } from 'react'

import BookCard from '@/components/BookCard'
import EmptyState from '@/components/CommonState/EmptyState'
import LoadingState from '@/components/CommonState/LoadingState'

import Trending from '../Trending'
import { cn, customJumpHref, handleDetailViewTrack } from '@/utils'
import { INovelDetail } from '@/api'

export interface IDiscoverResultProps {
  showHistory?: boolean
  data: INovelDetail[]
  loading?: boolean
  loadingMore?: boolean
  noMore?: boolean
  handleSearchTrending: (val: string) => void
  setHistoryStorage: (val: string) => void
  onLoadMore?: () => void
}

const DiscoverResult: FC<IDiscoverResultProps> = (props) => {
  const { showHistory, data, loading, loadingMore, noMore, handleSearchTrending, setHistoryStorage, onLoadMore } = props
  const lastTriggerScrollTopRef = useRef(-1)

  useEffect(() => {
    if (!data.length) {
      lastTriggerScrollTopRef.current = -1
    }
  }, [data])

  return (
    <div
      className={cn('relative h-[calc(100dvh-62px-104px-37px-37px)] overflow-y-scroll')}
      id='discoverResult'
      onScroll={(e) => {
        const target = e.currentTarget
        const scrollTop = target.scrollTop
        const distanceToBottom = target.scrollHeight - (scrollTop + target.clientHeight)
        const isNearBottom = distanceToBottom <= 50

        if (!isNearBottom || loadingMore || noMore) return
        if (scrollTop <= lastTriggerScrollTopRef.current) return

        lastTriggerScrollTopRef.current = scrollTop
        onLoadMore?.()
      }}
    >
      {data.length ? (
        <>
          {data.map((item) => {
            return (
              <BookCard
                key={`${item.resource_id}`}
                data={item}
                className={cn(
                  'mb-[22px] w-auto px-[37px] md:mb-0 md:flex-1 md:cursor-pointer md:items-center md:px-[37px] md:py-[11px] md:transition-all md:duration-300 md:hover:bg-color-white-trans10',
                )}
                infoClassName={cn('m-0 ml-[22px] w-auto flex-1 [&>span:first-child]:break-all justify-center')}
                onClick={() => {
                  handleDetailViewTrack({
                    resource_genre: item.tag_id,
                    resource_tag_id: item.plot_info?.map((item) => item.plot_id)?.join(',') || '',
                    resource_id: item.resource_id,
                    resource_type: item.resource_type,
                    cover_from: 10,
                  })
                  customJumpHref(`/cover/${item.resource_type}-${item.resource_id}`)
                }}
              />
            )
          })}
          <LoadingState show={Boolean(loadingMore)} className='g-loading-fixed-bottom bottom-[20px]' />
        </>
      ) : loading ? (
        <LoadingState show={true} className='g-loading-fixed-bottom' size='20px' />
      ) : showHistory ? (
        <Trending handleSearchTrending={handleSearchTrending} setHistoryStorage={setHistoryStorage} />
      ) : (
        <EmptyState className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2' iconName='BookEmpty' text='No results were found' />
      )}
    </div>
  )
}

export default DiscoverResult
